import { render } from "./PropostaTimeline.vue?vue&type=template&id=180ea1d4"
import script from "./PropostaTimeline.vue?vue&type=script&lang=js"
export * from "./PropostaTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__